import { render, staticRenderFns } from "./ScanRecordAdd.vue?vue&type=template&id=3ee20d70&scoped=true&"
import script from "./ScanRecordAdd.vue?vue&type=script&lang=js&"
export * from "./ScanRecordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee20d70",
  null
  
)

export default component.exports